import { useEffect } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { useLocalizedNavigate } from 'util/hooks';

function LanguageHandler() {
  const { lang } = useParams();
  const navigate = useLocalizedNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!lang) {
      void navigate(pathname, { replace: true });
    }
  }, [lang, navigate, pathname]);

  return <Outlet />;
}

export default LanguageHandler;
